<script setup lang="ts">
interface ToggleProps {
    active: boolean;
    size?: "md" | "sm";
    disabled?: boolean;
}

withDefaults(defineProps<ToggleProps>(), {
    size: "md",
    disabled: false,
});

const emit = defineEmits(["input"]);

const input = () => {
    emit("input");
};
</script>
<template>
    <div :class="['ds-toggle', size, { active, disabled }]" @click="input">
        <div class="toggle-wrapper">
            <div class="toggle-inner"></div>
        </div>
    </div>
</template>
<style scoped lang="scss">
.ds-toggle {
    width: 36px;
    height: 20px;
    cursor: pointer;
    display: flex;
    transition: 0.2s;

    .toggle-wrapper {
        width: 100%;
        height: 100%;
        padding: 0px 0px 0px 2px;
        display: flex;
        transition: 0.2s;
        align-items: center;
        border-radius: 10px;
        background-color: $stroke-soft-200;
        @include checkbox-shadow-disabled;

        &:hover {
            background-color: $stroke-sub-300;
        }

        .toggle-inner {
            width: 16px;
            height: 16px;
            border: none;
            transition: 0.2s linear;
            border-radius: 8px;
            background-color: $bg-white-0;
            @include checkbox-shadow-neutral;
        }
    }

    &.sm {
        width: 28px;
        height: 16px;

        .toggle-inner {
            width: 12px;
            height: 12px;
        }
    }

    &.active {
        .toggle-wrapper {
            background-color: $blue-base;
            @include checkbox-shadow-primary;

            &:hover {
                background-color: $blue-dark;
            }

            .toggle-inner {
                transform: translateX(100%);
            }
        }
    }

    &.disabled {
        cursor: default;
        pointer-events: none;

        .toggle-wrapper {
            background-color: $bg-weak-100;
            @include checkbox-shadow-disabled;

            .toggle-inner {
                box-shadow: none;
            }
        }
    }
}
</style>
